import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "../components/ui";
import LoginForm from "../components/user-profile-lite/LoginForm";

const Login = () => (
  <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
    <Row
     className='loginRow'
    >
      <Col md={12} style={{marginTop:window.screen.width < 767?65:{}}}>
        <LoginForm />
      </Col>
    </Row>
  </Container>
);

Login.propTypes = {
  /**
   * The small stats dataset.
   */
  smallStats: PropTypes.array
};

Login.defaultProps = {};

export default Login;
